import React from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../shared/TailwindComponents/Table';

interface EmployeeTimeTableProps {
  employeeTimeData: any[];
  timeInterval: 'daily' | 'weekly' | 'monthly' | 'yearly';
}

const EmployeeTimeTable: React.FC<EmployeeTimeTableProps> = ({ employeeTimeData, timeInterval }) => {
  const { t } = useTranslation();

  const columns = [t('Employee Name'), t('Total Duration'), t('Tasks'), t('Cases')];
  if (timeInterval === 'daily') columns.splice(1, 0, t('Date'));
  if (timeInterval === 'weekly') columns.splice(1, 0, t('Week Start'));
  if (timeInterval === 'monthly') columns.splice(1, 0, t('Month'));
  if (timeInterval === 'yearly') columns.splice(1, 0, t('Year'));

  const data = employeeTimeData.flatMap((employee) => 
    employee.data.map((entry: any) => ({
      [t('Employee Name')]: entry.user_name,
      ...(timeInterval === 'daily' && { [t('Date')]: new Date(entry.date).toLocaleDateString() }),
      ...(timeInterval === 'weekly' && { [t('Week Start')]: new Date(entry.week_start).toLocaleDateString() }),
      ...(timeInterval === 'monthly' && { [t('Month')]: new Date(entry.year, entry.month - 1).toLocaleString('default', { month: 'long' }) }),
      ...(timeInterval === 'yearly' && { [t('Year')]: entry.year }),
      [t('Total Duration')]: `${entry.duration.toFixed(2)} ${t('hours')}`,
      [t('Tasks')]: entry.task_id ? entry.task_id.join(', ') : t('No tasks'),
      [t('Cases')]: entry.case_id ? entry.case_id.join(', ') : t('No cases'),
    }))
  );

  return <Table columns={columns} data={data} />;
};

export default EmployeeTimeTable;
